import React, {PureComponent} from 'react';
import {ContactForm, GeneralContacts} from '../index';

class ContactUs extends PureComponent {

  state = {
    contacts: []
  };

  render() {
    const {text, contacts} = this.props;

    return (
      <div className="contacts container map">
        <section className="send-message">
          <div className="row title">
            <div className="col-lg-12 text-center">
              <div dangerouslySetInnerHTML={{__html: text.body}}/>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-4">
              <GeneralContacts contacts={contacts}/>
            </div>
            <div className="col-xs-12 col-md-8">
              <ContactForm/>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

ContactUs.propTypes = {};
ContactUs.defaultProps = {};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js